import React from 'react';
import { FaGlobe, FaMobileScreen, FaDesktop, FaApple, FaGooglePlay, FaWindows } from 'react-icons/fa6';
import codalyDesign from '../../img/codaly_design.png';
import './codaly.css';

/* Enlaces de Codaly. Todos llevan UTM para poder medir la migración desde web2barcode
   (utm_medium distingue landing pública vs. sesión iniciada). */
const CODALY_URL = 'https://codaly.com.mx';

export const codalyUrl = (path, medium) =>
    `${CODALY_URL}${path}?utm_source=web2barcode&utm_medium=${medium}&utm_campaign=migracion`;

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.codaly&referrer=utm_source%3Dweb2barcode%26utm_campaign%3Dmigracion';
export const APP_STORE_URL  = 'https://apps.apple.com/mx/app/codaly/id6757408227';

const external = { target: '_blank', rel: 'noopener noreferrer' };

/*******************************************************************************************/

export const ArrowIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
    </svg>
);

/* Captura del diseñador dentro de un marco de navegador; todo el bloque enlaza al diseñador */
export const DesignerShowcase = ({ medium }) => (
    <a href={codalyUrl('/designer', medium)} {...external} className="cdl-showcase" aria-label="Abrir el diseñador de Codaly">
        <div className="cdl-showcase-bar">
            <i style={{ background: '#f87171' }} />
            <i style={{ background: '#fbbf24' }} />
            <i style={{ background: '#34d399' }} />
            <span className="cdl-showcase-url">codaly.com.mx/designer</span>
        </div>
        <img src={codalyDesign} alt="Diseñador de etiquetas de Codaly" />
        <div className="cdl-showcase-overlay">
            <span className="cdl-btn cdl-btn-primary cdl-btn-lg">
                Abrir el diseñador <ArrowIcon />
            </span>
        </div>
    </a>
);

/*******************************************************************************************/

/* Diseñadores de Codaly: web, móvil y escritorio. `compact` oculta la lista de beneficios */
export const PlatformCards = ({ medium, compact = false }) => (
    <div className={`cdl-platforms ${compact ? 'cdl-compact' : ''}`}>
        <div className="cdl-platform">
            <div className="cdl-platform-icon"><FaGlobe /></div>
            <h4>Diseñador web</h4>
            <p>Desde cualquier navegador, sin instalar nada.</p>
            <ul>
                <li>Diseño visual: arrastra textos, códigos de barras, QR e imágenes</li>
                <li>Impresión directa en ZPL, TSPL y ESC/POS</li>
                <li>Conecta tus bases de datos y precios</li>
            </ul>
            <div className="cdl-platform-btns">
                <a href={codalyUrl('/designer', medium)} {...external} className="cdl-btn cdl-btn-primary cdl-btn-sm">
                    Abrir diseñador web <ArrowIcon />
                </a>
            </div>
        </div>

        <div className="cdl-platform">
            <div className="cdl-platform-icon"><FaMobileScreen /></div>
            <h4>App móvil</h4>
            <p>Diseña e imprime desde tu celular o tablet.</p>
            <ul>
                <li>Imprime etiquetas desde el piso de venta</li>
                <li>Verificador de precios</li>
                <li>Actualización de precios en tiempo real</li>
            </ul>
            <div className="cdl-platform-btns">
                <a href={PLAY_STORE_URL} {...external} className="cdl-btn cdl-btn-dark cdl-btn-sm">
                    <FaGooglePlay /> Google Play
                </a>
                <a href={APP_STORE_URL} {...external} className="cdl-btn cdl-btn-dark cdl-btn-sm">
                    <FaApple /> App Store
                </a>
            </div>
        </div>

        <div className="cdl-platform">
            <div className="cdl-platform-icon"><FaDesktop /></div>
            <h4>App de escritorio</h4>
            <p>Para Windows y macOS.</p>
            <ul>
                <li>Imprime en ZPL, TSPL y ESC/POS</li>
                <li>Las mismas etiquetas que en web y móvil</li>
                <li>Ideal para estaciones de impresión</li>
            </ul>
            <div className="cdl-platform-btns">
                <a href={codalyUrl('/downloads', medium)} {...external} className="cdl-btn cdl-btn-dark cdl-btn-sm">
                    <FaWindows /> <FaApple /> Descargar
                </a>
            </div>
        </div>
    </div>
);
